/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Link from 'material/ctas/link/link_container';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/backtoembeds/backtoembeds_styles';



/* ========== ~~~~~~~~~~ CTA : CREATE EMBED BUTTON  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const BackToEmbedsCTA = (props) => {

	return (
		<div onClick={props.getClientEmbedsData}>
            <Link
                name={`backtoembeds`}
                type={`internal`}
                behavior={`back`}
                text={`Back to all embeds`}
                color={`primary`}
                action={`dashboard/embeds`}
                icon={<Icon name={`hand-point-left`} />}
            />
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(BackToEmbedsCTA);